import { render, staticRenderFns } from "./TeamCircles.vue?vue&type=template&id=1e64c40d&scoped=true&"
import script from "./TeamCircles.vue?vue&type=script&lang=js&"
export * from "./TeamCircles.vue?vue&type=script&lang=js&"
import style0 from "./TeamCircles.vue?vue&type=style&index=0&id=1e64c40d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e64c40d",
  null
  
)

export default component.exports